import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Drawer, List, ListItem, ListItemIcon, ListItemText, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import LockIcon from "@mui/icons-material/Lock";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LogoutIcon from "@mui/icons-material/ExitToApp";
import {
  createStyles,
  Header,
  Group,
  Button,
  UnstyledButton,
  ThemeIcon,
  Box,
  Burger,
  rem,
} from "@mantine/core";
import { logout, setShowLogin, setRedirectUrl } from "../Redux/user/slice";
import brandLogo from "./../assets/brand.png";
import { MobileMenuConfig } from "../configs/MenuConfig";
import { FormattedMessage } from "react-intl";
const MobileMenuIcon = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

const MobileMenuHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(3),
}));

const MobileMenuList = styled(List)({
  width: "20%",
  paddingLeft: 0, // Remove default padding
  justifyContent: "flex-start", // Align to the left
});

const MobileMenuItem = styled(ListItem)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-start", // Align to the left
  alignItems: "left",
  marginBottom: theme.spacing(1),
  whiteSpace: "nowrap", // Prevent wrapping
  // Only add typography styling here
  "& .MuiListItemText-primary": {
    fontFamily: "'Montserrat', sans-serif",
    fontSize: "15px",
    fontWeight: 500,
    color: "#2C3E50" // Dark blue-gray color for better visibility
  },
  "& .MuiListItemIcon-root": {
    color: "#3498DB" // Blue color for icons
  }
}));

const MobileMenuPanel = ({ selectedLanguage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { redirectUrl } = useSelector((state) => state.user);
  const { userInfo } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);

  const handleSignup = () => {
    setOpen(false);
    navigate('/signup-form');
  };

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem("userLogged");
    localStorage.removeItem("userinfo");
    // Preserve tour completion on logout
    setOpen(false);
    if (window.location.pathname === "/my-list") {
      window.location.href = "/";
    }
  };

  const handleLoginClick = () => {
    dispatch(setShowLogin({ value: true, cb: handleSuccessfulLogin }));
    setOpen(false);
  };

  const handleSuccessfulLogin = () => {
    // Reload the page
    window.location.reload();
  };

  const isUserLogged = localStorage.getItem("userLogged");
  //TODO isUserLoggedIn lost its value by unknown reasons after validateUserAPI execution

  const activate = ({ url, enableAuthentication, newPage }) => {
    const isMyListPage = url === "/my-list";

    if (isMyListPage && !isUserLogged) {
      dispatch(setRedirectUrl({ redirectUrl: url }));
      dispatch(setShowLogin({ value: true, cb: () => window.location.replace(url) }));
      setOpen(false);
    } else if (newPage) {
      window.open(url, "_blank");
    } else {
      window.location.replace(url);
    }
  };

  return (
    <>
      <MobileMenuHeader>
        <MobileMenuIcon onClick={handleDrawerToggle}>{open ? <CloseIcon /> : <MenuIcon />}</MobileMenuIcon>
        <img src={brandLogo} alt="Brand Logo" style={{ width: "30%", height: "auto" }} />
      </MobileMenuHeader>
      <Drawer
        anchor="left"
        open={open}
        onClose={handleDrawerToggle}
        sx={{
          width: "80%", // Set the width to 80%
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: "80%",
          },
        }}
      >
        <MobileMenuList>
          {MobileMenuConfig.filter((x) => x.name !== "User").map((item, index) => (
            <MobileMenuItem
              key={index}
              onClick={() => activate(item)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={<FormattedMessage id={`menu.${item.name}`} />} />
            </MobileMenuItem>
          ))}
          {!userInfo?.userId && (
            <>
              <MobileMenuItem
                onClick={handleLoginClick}
              >
                <ListItemIcon>
                  <LockIcon />
                </ListItemIcon>
                <ListItemText primary={<FormattedMessage id="menu.login" />} />
              </MobileMenuItem>
              <MobileMenuItem
                onClick={handleSignup}
              >
                <ListItemIcon>
                  <PersonAddIcon />
                </ListItemIcon>
                <ListItemText primary={<FormattedMessage id="menu.signup" />} />
              </MobileMenuItem>
            </>
          )}
          {userInfo?.userId && (
            <MobileMenuItem onClick={handleLogout}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary={<FormattedMessage id="menu.logout" />} />
            </MobileMenuItem>
          )}
          {/* Close button to close the drawer */}
          <MobileMenuItem onClick={handleDrawerToggle}>
            <ListItemIcon>
              <CloseIcon />
            </ListItemIcon>
            <ListItemText primary={<FormattedMessage id="menu.close" />} />
          </MobileMenuItem>
        </MobileMenuList>
      </Drawer>
    </>
  );
};

export default MobileMenuPanel;